module.exports = __webpack_public_path__ + "img/nocover.2c3889ca.png";